import { render, staticRenderFns } from "./dataSummary.vue?vue&type=template&id=3b2067df&scoped=true"
import script from "./dataSummary.vue?vue&type=script&lang=js"
export * from "./dataSummary.vue?vue&type=script&lang=js"
import style0 from "./dataSummary.vue?vue&type=style&index=0&id=3b2067df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2067df",
  null
  
)

export default component.exports